<ng-container *ngIf="currentListViewState" ntapDynamicFormProvider>
    <ng-container ntapFilterViewProvider [viewName]="currentListViewName" [viewState]="currentListViewStateFilter">
        <ng-container ntapListViewProvider [viewName]="currentListViewName" [viewState]="currentListViewState">
            <ntap-dynamic [compId]="INIT_COMP_ID"></ntap-dynamic>
                <p-toolbar styleClass="p-mb-4">
                  <ng-template pTemplate="right">
                    <p-button [disabled] = "(disabled$ | async) ?? true" pRipple label="Potvrdi"
                    (onClick) = "razmjestFizickeObjekteIzVisihRazina()"></p-button>
                  </ng-template>
                </p-toolbar>
        </ng-container>
    </ng-container>
</ng-container>